import { render, staticRenderFns } from "./InterfaceImageUpload.vue?vue&type=template&id=2f3252d3"
import script from "./InterfaceImageUpload.vue?vue&type=script&lang=js"
export * from "./InterfaceImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports